import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=bdfd664a&scoped=true&"
import script from "./UserList.vue?vue&type=script&lang=js&"
export * from "./UserList.vue?vue&type=script&lang=js&"
import style0 from "./UserList.vue?vue&type=style&index=0&id=bdfd664a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfd664a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdfd664a')) {
      api.createRecord('bdfd664a', component.options)
    } else {
      api.reload('bdfd664a', component.options)
    }
    module.hot.accept("./UserList.vue?vue&type=template&id=bdfd664a&scoped=true&", function () {
      api.rerender('bdfd664a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/UserList.vue"
export default component.exports